import { render, staticRenderFns } from "./BxLcdjModal.vue?vue&type=template&id=5df52926&"
import script from "./BxLcdjModal.vue?vue&type=script&lang=js&"
export * from "./BxLcdjModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports